import { getIdToken, getRefreshToken } from "src/api/tokenStorage";

// This is what we want to return, so define it explicitly
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type EmptyObject = {};

export const authHeader = (
  refresh: boolean,
): { Authorization: string } | EmptyObject => {
  const token = refresh ? getRefreshToken() : getIdToken();
  return token ? { Authorization: "Bearer " + token } : {};
};
